export default class TrackScreenString { }

// NB: Google Analytics naming convention for Events and Parameters is Snake Case 
TrackScreenString.START_SCREEN = "start_screen";
TrackScreenString.INTRODUCTION_VIDEO = "introduction_video";
TrackScreenString.COMM_PER_CH1_INTRO = "comm_per_ch1_intro";
TrackScreenString.CHAPTER1_BRIEFING = "chapter1_briefing";
TrackScreenString.TUTORIAL = "tutorial";
TrackScreenString.CHAPTER2_BRIEFING = "chapter2_briefing";
TrackScreenString.CHAPTER3_BRIEFING = "chapter3_briefing";
TrackScreenString.COMM_PER_3_OUTRO = "comm_per_3_outro";
TrackScreenString.SIM_EPILOGUE = "sim_epilogue";
TrackScreenString.CREDIT_SCREEN = "credit_screen";